import { Decimal } from 'decimal.js'
import { Currency } from '../models/Currency'
import type { Money } from '~/shared/money/models/Money'

export function useMoneyDefault (amount: Decimal.Value = 0, currency: Currency = Currency.BRL): Money {
  return { amount: new Decimal(amount), currency }
}
